module.exports = __webpack_public_path__ + "static/media/Messages.f3e03730.png";